"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THAI_UNICODE_RANGE = void 0;
// Source: https://en.wikipedia.org/wiki/Thai_(Unicode_block)
// Thai (Unicode block) 0E00-0E7F
exports.THAI_UNICODE_RANGE = [[3584, 3711]];
